'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var learnMap = function learnMap() {
  return import('@/page/learnMap');
};
exports.default = [{
  path: '/learnMap',
  name: 'learnMap',
  component: learnMap
}];